const dateFormat = (input) => {
  if (!input) return "";
  const [year, month, day] = input.split('-').map(Number);
  const localDate = new Date(year, month - 1, day);
  return localDate.toLocaleDateString('en-US');
};

export default dateFormat;
